import motorJuridico from "./motorJuridico";
import motorTrabalhista from "./motorTrabalhista";

const gerarPeticaoInteligente = (peticao) => {

  // 🔥 UNIFICA TODOS OS DADOS
  const dados = {
    ...peticao.formulario,
    nomeCliente: peticao.nomeCliente,
    clienteId: peticao.clienteId,
  };

  const descricao = dados?.juridico?.fatos || "";

  // 🔍 ANALISA A ÁREA
  const analise = motorJuridico(descricao);

  // 🧠 BASE PADRÃO
  let resultado = {
    termosPartes: {
      autor: "AUTOR",
      reu: "RÉU",
      nomePeticao: "(nome da petição)"
    },
    fatos: [descricao || "Descrição do caso não informada."],
    fundamentos: [],
    pedidos: [],
    valorCausa: "0,00"
  };

  // 🔥 FORÇA DETECÇÃO DE ÁREA PELO FORMULÁRIO
let areaDetectada = analise?.areas?.[0];

if (!areaDetectada) {
  if (dados?.contrato || dados?.juridico) {
    areaDetectada = "trabalhista";
  }
}

  // ⚖️ ESCOLHE O MOTOR
  switch (areaDetectada) {

  case "trabalhista":
    resultado = motorTrabalhista(dados);
    break;

  default:
    resultado.fundamentos = [
      "Nos termos da legislação aplicável, os fatos narrados demonstram a necessidade de intervenção judicial."
    ];

    resultado.pedidos = [
      "Condenação da parte ré nas verbas devidas",
      "Pagamento de honorários advocatícios"
    ];

    resultado.valorCausa = "10.000,00";
}

  const termos = resultado.termosPartes || {
    autor: "AUTOR",
    reu: "RÉU",
    nomePeticao: "(nome da petição)"
  };

  console.log("ANALISE:", analise);

  // 🔥 HTML FINAL (CORRIGIDO)
  return `
    <p style="text-align:center;"><strong>EXCELENTÍSSIMO SENHOR DOUTOR JUIZ</strong></p>

    <br/>

    <p><strong>${termos.autor}:</strong> ${dados.nomeCliente || "NOME NÃO INFORMADO"}</p>
    <p><strong>${termos.nomePeticao}</strong></p>
    <p><strong>${termos.reu}:</strong> ${dados?.contrato?.empresa || "A identificar"}</p>

    <br/>

    <p><strong>DOS FATOS</strong></p>
    ${
      resultado.fatos
        .map(f => `<p style="text-indent:2cm; text-align:justify;">${f}</p>`)
        .join("")
    }

    <br/>

    <p><strong>DO DIREITO</strong></p>
    ${
      resultado.fundamentos
        .map(f => `<p style="text-align:justify;">${f}</p>`)
        .join("")
    }

    <br/>

    <p><strong>DOS PEDIDOS</strong></p>
    <ul>
      ${resultado.pedidos.map(p => `<li>${p}</li>`).join("")}
    </ul>

    <br/>

    <p><strong>VALOR DA CAUSA</strong></p>
    <p>R$ ${resultado.valorCausa}</p>

    <br/>

    <p>Termos em que,<br/>Pede deferimento.</p>

    <br/>

    <p>${peticao?.advogado?.nome || ""}</p>
  `;
};

export default gerarPeticaoInteligente;